import translate from "@/i18n/translate";
import { ReportingYears } from "./ReportingYears";
import UnauthorizedComponent from "@/features/insights/UnauthorizedComponent";
import { usePageTitle } from '@/hooks/usePageTitle';
import { useIntl } from 'react-intl';

export interface InsightsSettingsProps {
  auth: Boolean;
}
export function InsightsSettings({ auth }: InsightsSettingsProps) {
  const intl = useIntl();
  const pageTitle = intl.formatMessage({ id: 'app.pageTitle.settings' });
  usePageTitle(pageTitle);
  return (
    <>
      {auth ? (
        <>
          <div className="page-header">
            <div className="title-container home-settings">
              <div>
                <div id="main-heading" className="title">{translate("app.home.settings")}</div>
                <div className="settings-title-description">
                  {translate("app.settings.desc")}
                </div>
              </div>
            </div>
          </div>
          <ReportingYears />
        </>
      ) : (
        <UnauthorizedComponent />
      )}
    </>
  );
}
